import { developerCompFrenchData } from "./developer.data";
import { developerCompEnglishData } from "./developer.data";
import {
  graphicDesignerCompEnglishData,
  graphicDesignerCompFrenchData,
} from "./graphic-designer.data";
import { profileCompEnglishData } from "./profile.data";
import { profileCompFrenchData } from "./profile.data";

export const HOME_MAIN_COMP_DATA = {
  en: [
    profileCompEnglishData,
    developerCompEnglishData,
    graphicDesignerCompEnglishData,
  ],
  fr: [
    profileCompFrenchData,
    developerCompFrenchData,
    graphicDesignerCompFrenchData,
  ],
};
